import React from 'react';

import { IconProps } from '../../../DefaultIcon';

export function CessationManagementIcon({ className }: IconProps) {
  return (
    <svg
      width="78"
      height="78"
      viewBox="0 0 78 78"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_812_607)">
        <path
          d="M68.9401 78V3.53902C68.9401 1.58076 67.3593 0 65.4011 0H3.53902C1.58076 0 0 1.58076 0 3.53902V68.5154C0 73.7532 4.24682 78 9.48457 78H68.9401Z"
          fill="#EAEDF8"
        />
        <path
          d="M9.60254 78.0001C14.1797 78.0001 17.9782 74.6026 18.5681 70.1906C18.6624 69.4828 19.2523 68.9402 19.9601 68.9402H76.4192C77.3158 68.9402 77.9764 69.7424 77.8112 70.6153C77.0327 74.815 73.3285 78.0001 68.8929 78.0001H9.60254Z"
          fill="#00C4B3"
        />
        <path
          d="M68.1383 66.3684C67.2181 66.3684 66.298 66.0145 65.5902 65.3067L37.3488 37.0654C35.9332 35.6498 35.9332 33.3612 37.3488 31.9692C38.7644 30.5536 41.053 30.5536 42.445 31.9692L70.6864 60.2106C72.102 61.6262 72.102 63.9147 70.6864 65.3067C69.9786 66.0145 69.0584 66.3684 68.1383 66.3684Z"
          fill="#00C4B3"
        />
        <path
          d="M37.8713 15.5731L19.8535 33.5908L32.566 46.3033L50.5838 28.2856L37.8713 15.5731Z"
          fill="#00416B"
        />
        <path
          d="M51.5751 27.2977L54.2176 24.6552C55.7512 23.1217 55.7512 20.6208 54.2176 19.0872L47.0924 11.9619C45.5588 10.4284 43.0579 10.4284 41.5243 11.9619L38.8818 14.6044L51.5987 27.2977H51.5751Z"
          fill="#00C4B3"
        />
        <path
          d="M18.8044 34.6588L16.1619 37.3013C14.6283 38.8349 14.6283 41.3358 16.1619 42.8694L23.2871 49.9946C24.8207 51.5282 27.3216 51.5282 28.8552 49.9946L31.4977 47.3521L18.8044 34.6353V34.6588Z"
          fill="#00C4B3"
        />
      </g>
      <defs>
        <clipPath id="clip0_812_607">
          <rect width="77.8584" height="78" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}
